function resize() {
  const height = document.querySelector("#root").scrollHeight;
  window.parent.postMessage(["setHeight", height], "*");
}

export { resize };
